var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 0.999129,
    id: "gradient_1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1454BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51000315,
    stopColor: "#2119AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999129,
    stopColor: "#5811B6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.56923 0L17.4308 0C18.8477 0 20 1.15231 20 2.56923L20 17.4308C20 18.8477 18.8477 20 17.4308 20L2.56923 20C1.15231 20 0 18.8477 0 17.4308L0 2.56923C0 1.15231 1.15231 0 2.56923 0ZM17.4308 18.4615C17.9992 18.4615 18.4615 17.9992 18.4615 17.4308L18.4615 2.56923C18.4615 2.00077 17.9992 1.53846 17.4308 1.53846L2.56923 1.53846C2.00077 1.53846 1.53846 2.00077 1.53846 2.56923L1.53846 17.4308C1.53846 17.9992 2.00077 18.4615 2.56923 18.4615L17.4308 18.4615Z",
    transform: "translate(22 22)",
    id: "Shape-Copy",
    fill: "url(#gradient_1)",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.56923 0L17.4308 0C18.8477 0 20 1.15231 20 2.56923L20 17.4308C20 18.8477 18.8477 20 17.4308 20L2.56923 20C1.15231 20 0 18.8477 0 17.4308L0 2.56923C0 1.15231 1.15231 0 2.56923 0ZM17.4308 18.4615C17.9992 18.4615 18.4615 17.9992 18.4615 17.4308L18.4615 2.56923C18.4615 2.00077 17.9992 1.53846 17.4308 1.53846L2.56923 1.53846C2.00077 1.53846 1.53846 2.00077 1.53846 2.56923L1.53846 17.4308C1.53846 17.9992 2.00077 18.4615 2.56923 18.4615L17.4308 18.4615Z",
    transform: "translate(22 0)",
    id: "Shape-Copy-3",
    fill: "url(#gradient_1)",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.56923 0L17.4308 0C18.8477 0 20 1.15231 20 2.56923L20 17.4308C20 18.8477 18.8477 20 17.4308 20L2.56923 20C1.15231 20 0 18.8477 0 17.4308L0 2.56923C0 1.15231 1.15231 0 2.56923 0ZM17.4308 18.4615C17.9992 18.4615 18.4615 17.9992 18.4615 17.4308L18.4615 2.56923C18.4615 2.00077 17.9992 1.53846 17.4308 1.53846L2.56923 1.53846C2.00077 1.53846 1.53846 2.00077 1.53846 2.56923L1.53846 17.4308C1.53846 17.9992 2.00077 18.4615 2.56923 18.4615L17.4308 18.4615Z",
    transform: "translate(0 22)",
    id: "Shape-Copy-2",
    fill: "url(#gradient_1)",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.56923 0L17.4308 0C18.8477 0 20 1.15231 20 2.56923L20 17.4308C20 18.8477 18.8477 20 17.4308 20L2.56923 20C1.15231 20 0 18.8477 0 17.4308L0 2.56923C0 1.15231 1.15231 0 2.56923 0ZM17.4308 18.4615C17.9992 18.4615 18.4615 17.9992 18.4615 17.4308L18.4615 2.56923C18.4615 2.00077 17.9992 1.53846 17.4308 1.53846L2.56923 1.53846C2.00077 1.53846 1.53846 2.00077 1.53846 2.56923L1.53846 17.4308C1.53846 17.9992 2.00077 18.4615 2.56923 18.4615L17.4308 18.4615Z",
    id: "Shape-Copy-4",
    fill: "url(#gradient_1)",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApps);
export default __webpack_public_path__ + "static/media/apps.d0a864afe108b58e129f9871330a4225.svg";
export { ForwardRef as ReactComponent };